import React, { useState, useEffect } from 'react';
import TaskPopup from './taskPopup';
import { apiFetch } from './api';

const TaskListe = ({ projektId }) => {
  const [tasks, setTasks] = useState([]);
  const [neu, setNeu] = useState(false);
  const [name, setName] = useState('');
  const [offeneTask, setOffeneTask] = useState(null);
  const [loading, setLoading] = useState(true);

  const lade = async () => {
    const res = await apiFetch(`/tasks?projekt_id=${projektId}`);
    const data = await res.json();
    setTasks(data);
    setLoading(false);
  };

  useEffect(() => { lade(); }, [projektId]);

  const erstellen = async () => {
    if (!name) return;
    await apiFetch('/tasks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, projekt_id: projektId })
    });
    setName('');
    setNeu(false);
    lade();
  };

  const statusFarbe = (status) => {
    const f = { offen: '#9b9b9b', 'in arbeit': '#1565c0', erledigt: '#2e7d32' };
    return f[status] || '#9b9b9b';
  };

  const formatZeit = (minuten) => {
    if (!minuten || minuten === 0) return null;
    const h = Math.floor(minuten / 60);
    const m = minuten % 60;
    if (h === 0) return `${m}min`;
    if (m === 0) return `${h}h`;
    return `${h}h ${m}min`;
  };

  const gesamtMinuten = tasks.reduce((sum, t) => sum + (t.erfasste_minuten || 0), 0);

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {loading ? (
          <p style={{ fontSize: '12px', color: '#c4c4c4', margin: 0 }}>Lädt...</p>
        ) : tasks.length === 0 && !neu ? (
          <p style={{ fontSize: '12px', color: '#c4c4c4', margin: '0 0 4px 0' }}>Noch keine Tasks</p>
        ) : (
          tasks.map((t) => (
            <div key={t.id} onClick={() => setOffeneTask(t.id)} style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '8px 10px', backgroundColor: '#fafafa', borderRadius: '6px',
              cursor: 'pointer', fontSize: '13px', color: '#1a1a1a'
            }}>
              <span style={{
                width: '7px', height: '7px', borderRadius: '50%',
                backgroundColor: statusFarbe(t.status), flexShrink: 0
              }} />
              <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</span>
              {formatZeit(t.erfasste_minuten) && (
                <span style={{ fontSize: '11px', color: '#9b9b9b', flexShrink: 0 }}>{formatZeit(t.erfasste_minuten)}</span>
              )}
            </div>
          ))
        )}
      </div>

      {!loading && tasks.length > 0 && gesamtMinuten > 0 && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '8px 10px', marginTop: '4px', borderTop: '1px solid #efefef'
        }}>
          <span style={{ fontSize: '11px', color: '#9b9b9b' }}>Gesamt</span>
          <span style={{ fontSize: '12px', fontWeight: '600', color: '#1a1a1a' }}>{formatZeit(gesamtMinuten)}</span>
        </div>
      )}

      {neu ? (
        <div style={{ marginTop: '8px' }}>
          <input type="text" value={name} autoFocus
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') erstellen(); if (e.key === 'Escape') { setNeu(false); setName(''); } }}
            placeholder="Taskname..."
            style={{
              width: '100%', padding: '8px 10px', fontSize: '13px', border: '1px solid #e8e8e8',
              borderRadius: '6px', outline: 'none', boxSizing: 'border-box', marginBottom: '6px'
            }}
          />
          <div style={{ display: 'flex', gap: '6px' }}>
            <button onClick={erstellen} style={{
              padding: '5px 12px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
              borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer'
            }}>Anlegen</button>
            <button onClick={() => { setNeu(false); setName(''); }} style={{
              padding: '5px 12px', backgroundColor: 'transparent', color: '#9b9b9b',
              border: '1px solid #e8e8e8', borderRadius: '6px', fontSize: '12px', cursor: 'pointer'
            }}>Abbrechen</button>
          </div>
        </div>
      ) : (
        <button onClick={() => setNeu(true)} style={{
          marginTop: '8px', width: '100%', padding: '8px', backgroundColor: 'transparent',
          color: '#6b6b6b', border: '1px dashed #d4d4d4', borderRadius: '6px',
          fontSize: '12px', cursor: 'pointer'
        }}>+ Neue Task</button>
      )}

      {offeneTask && (
        <TaskPopup taskId={offeneTask} onClose={() => { setOffeneTask(null); lade(); }} />
      )}
    </div>
  );
};

export default TaskListe;